import store from "@/store";
import { useAuth } from "./useAPI";

export default function useSessionValidate() {
  const { sessionValidate } = useAuth();

  const useRouterSessionValidate = async () => {
    const sessionToken = store.getters["auth/getSessionToken"]();
    if (!sessionToken) return false; // 토큰이 없는 경우
    try {
      const { alive } = await sessionValidate(sessionToken);
      return alive;
    } catch {
      return false;
    }
  };

  return {
    useRouterSessionValidate,
  };
}
